import { BLOCK_CSS } from '@/types';
var BASE;
(function (BASE) {
    BASE["PADDING"] = "0px";
})(BASE || (BASE = {}));
const templates = {
    padding: '{top} {right} {bottom} {left}'
};
// biome-ignore lint/suspicious/noExplicitAny: Any is required as cssReplace is a generic function
const cssReplace = (template, data) => {
    const pattern = /{\s*(\w+?)\s*}/g; // {property}
    return template.replace(pattern, (_, token) => data[token] || '');
};
export const getPaddingValue = (p) => BLOCK_CSS.PaddingType[p] || BASE.PADDING;
export const getPadding = (p) => ({
    bottom: getPaddingValue(p === null || p === void 0 ? void 0 : p.bottom),
    left: getPaddingValue(p === null || p === void 0 ? void 0 : p.start),
    right: getPaddingValue(p === null || p === void 0 ? void 0 : p.end),
    top: getPaddingValue(p === null || p === void 0 ? void 0 : p.top)
});
export function convertToCSS({ alignment, padding, textAlignment } = {}) {
    const paddingVal = getPadding(padding);
    return {
        justifyContent: BLOCK_CSS.AlignmentType[alignment],
        padding: cssReplace(templates.padding, paddingVal),
        textAlign: BLOCK_CSS.AlignmentType[textAlignment]
    };
}
